import React from 'react';

// Navbar público para evaluador: solo logo, nombre de la app y bienvenida
const NavbarEvaluator = ({ evaluatorName }) => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-brand" style={{ textDecoration: 'none' }}>
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" className="navbar-logo" />
            <span>GP Forms</span>
          </div>
          <div className="navbar-user" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span className="nav-link" style={{ color: '#19B394', fontWeight: 600, fontSize: 16 }}>
              Bienvenido(a) {evaluatorName || ''}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarEvaluator;


